import mprlogo from './mpr.svg';

export const LOGOS_MAP = {
    mprlogo,
};
